import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=68579ba6&scoped=true&"
var script = {}
import style0 from "./shop.vue?vue&type=style&index=0&id=68579ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68579ba6",
  null
  
)

export default component.exports